'use strict';

angular.module('amexReconciliationApp')
  .directive('cardSortableColumnHeader', function (CardSortModel) {
    return {
      restrict: 'A',
      link: function(scope, element, attributes) {
        var sortColumnName = attributes.cardSortableColumnHeader;
        var icon = angular.element('<span tabindex="0" class="fa"></span>');

        element.on('click', function() {
          CardSortModel.setSortField(sortColumnName);
        });
        element.append(icon);
        element.addClass('sortable-column-header');

        CardSortModel.onSortOrderChanged(scope, updateIconClass);

        function sortingClass(sortInfo) {
          if (sortInfo.field !== sortColumnName) {
            return 'fa-sort';
          }

          return sortInfo.direction === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
        }

        function updateIconClass(sortInfo) {
          icon.attr('class', 'fa ' + sortingClass(sortInfo));
        }
      }
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/cardSortableColumnHeader.js
// module id = 516
// module chunks = 0